import IMask from 'imask';

export default function Banner() {

    document.querySelectorAll('.block-banner')
        .forEach(callback => {

            document.querySelectorAll('form')
                .forEach(form => {
                    let fieldset = form.querySelector('fieldset'),

                        number_input = form.querySelector('input[name=number]'),
                        //number_int,
                        number_masked,
                        number_valid = false,
                        number,

                        submit = form.querySelector('input[type="submit"]'),
                        sending = false;

                    // init input internation number
                    //number_int = intlTelInput(number_input, configTelInput);

                    // init input mask
                    number_masked = IMask(number_input, {
                        mask: '+{7}(000)000-00-00',
                        lazy: false,
                        placeholderChar: '_'
                    })
                        // event complete
                        .on('complete', function () {
                            number = number_masked.unmaskedValue;
                            number_valid = validNumber(number, 11);

                            if (number_valid) {
                                number_input.classList.remove('uk-form-danger')
                            } else {
                                number_input.classList.add('uk-form-danger')
                            }
                        });
                    // event focusout
                    number_input.addEventListener('focusout', function () {
                        number = number_masked.unmaskedValue;
                        number_valid = validNumber(number, 11);
                        if (number_valid) {
                            number_input.classList.remove('uk-form-danger')
                        } else {
                            number_input.classList.add('uk-form-danger')
                        }
                    });
                    // event submit
                    submit.addEventListener('click', (e) => {
                        e.preventDefault();

                        let number = number_masked.unmaskedValue,
                            valid = validNumber(number, 11);

                        if (!sending && valid) {
                            sending = true
                            if (typeof ComagicWidget !== 'undefined') {
                                ComagicWidget.sitePhoneCall({'phone': number.replace(/[^0-9]/g, '')}, function (response) {
                                    if (response.success) {

                                        callback.classList.add(['block-banner__success']);

                                        createAlert(form, {
                                            class: '',
                                            message: 'Спасибо за обращение, мы перезвоним Вам в самое ближайшее время!'
                                        });

                                    } else {
                                        createAlert(form, {
                                            class: 'block-banner__errors',
                                            message: 'При отправке запроса возникла ошибка.'
                                        });
                                    }
                                });
                            } else {
                                createAlert(form, {
                                    class: 'block-banner__errors',
                                    message: 'Обратный звонок временно не работает.'
                                });
                            }
                            sending = false
                        } else if (!valid) {
                            number_input.classList.add('uk-form-danger')
                            createAlert(form, {
                                class: 'block-banner__errors',
                                message: 'Номер телефона заполнен некорректно'
                            });
                        }

                    });
                });
        });

    function createAlert(form, data) {
        clearAlerts(form);

        let alert = document.createElement('div');

        alert.classList = data.class;
        alert.innerHTML = data.message;
        form.querySelector('fieldset').before(alert);
    }

    function clearAlerts(form) {
        form.querySelectorAll('.block-banner__errors').forEach(alert => {
            alert.remove();
        });
    }

    function validNumber(number, lenght) {
        return number.replace(/[^0-9]/g, '').length === lenght;
    }
}
